export default ({ inputElement, onFinished, onPlaceChange, isFullAddress }) => {
  if (!window.google?.maps?.places?.Autocomplete || !inputElement) {
    return;
  }

  const options = {
    componentRestrictions: { country: 'GB' },
    types: [isFullAddress ? 'address' : 'geocode'],
    fields: ['formatted_address', 'address_components', 'geometry.location'],
  };

  const autocomplete = new window.google.maps.places.Autocomplete(
    inputElement,
    options,
  );

  onFinished();

  inputElement.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  });

  autocomplete.addListener('place_changed', () =>
    onPlaceChange(autocomplete.getPlace()),
  );
};
